import { BankOperationRelatedTypes, BankOperationSingleTypes } from 'constants/bankOperationTypes';
import { Directions } from 'constants/directions';

import { Dispatch, SetStateAction, useMemo } from 'react';

import { RequestsBankOpsForm } from 'pages/Finance/RequestsBankOps/components/RequestsBankOpsForm';
import { useFormContext } from 'react-hook-form';
import { getId } from 'utils';

type Props = {
  isRelated: boolean;
  setIsRelated: Dispatch<SetStateAction<boolean>>;
  errors: any;
};

export const RequestsBankOpsCreateForm: React.FC<Props> = ({ isRelated, setIsRelated, errors }) => {
  const { watch, unregister, register, setValue } = useFormContext();
  const [referral, merchant, provider, type] = watch(['referral', 'merchant', 'provider', 'type']);

  const isSwitcherDisabled = useMemo(
    () => getId(type) !== BankOperationRelatedTypes.Transfer,
    [type],
  );

  const onTypeChange = (value: string) => {
    const setRelatedOperation = () => {
      setIsRelated(true);
      register('related');
      setValue('direction', `/admin/directions/${Directions.Payout}`);
      setValue('related.direction', `/admin/directions/${Directions.Payment}`);
    };

    switch (getId(value)) {
      case BankOperationRelatedTypes.Conversion:
        setRelatedOperation();
        setValue('related.referral', referral);
        setValue('related.merchant', merchant);
        setValue('related.provider', provider);
        return;
      case BankOperationRelatedTypes.ConversionReferrals:
        setRelatedOperation();
        return;
      case BankOperationSingleTypes.Percentage:
        setValue('direction', `/admin/directions/${Directions.Payout}`);
        setIsRelated(false);
        return;
      default:
        setIsRelated(false);
        unregister('related');
        return;
    }
  };

  return (
    <RequestsBankOpsForm
      errors={errors}
      isRelated={isRelated}
      isRelatedSwitcherDisabled={isSwitcherDisabled}
      onTypeChange={onTypeChange}
      setIsRelated={setIsRelated}
    />
  );
};
